/* ================================================== */
/* SLIDE FADE TOGGLE
/* ================================================== */

$.fn.slideFadeToggle = function(speed, easing, callback) {
	var speed = (typeof speed === 'undefined') ? 200 : speed;
	return this.animate({ opacity: 'toggle', height: 'toggle' }, speed, easing, callback);
};